module.exports = __webpack_public_path__ + "static/media/logo-bradesco.736191cd.svg";